import styled from 'styled-components';

import Image from '../../../../Core/Image';
import Ctas from '../../../../Core/Ctas';

export const Card = styled.li`
  display: flex;
  flex-direction: column;
  padding: 1.5rem 0.5rem;
  gap: 0.5rem;
  min-height: 16.4rem;
`;

export const Img = styled(Image)`
  height: 100%;
  width: 100%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  object-fit: contain;
  max-height: 3rem;
  max-width: 3rem;
  margin-bottom: 0.5rem;
`;

export const Heading = styled.span`
  position: relative;
  font-weight: 600;
  font-size: 1.125rem;
  line-height: 130%;
`;

export const StyledCtas = styled(Ctas)`
  margin: 0;
`;
